import React, { Component } from 'react';
import "./Navbar.css";
// import {
//     Collapse,
//     Navbar,
//     NavbarToggler,
//     NavbarBrand,
//     Nav,
//     NavItem,
//     NavLink,
//     Container,
//     Row,
//     Col,
//     Jumbotron,
//     Button
// } from 'reactstrap';
class NavbarCustom extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
        isOpen: false
    };
}
toggle() {
    this.setState({
        isOpen: !this.state.isOpen
    });
}
  render() {
    return(
  <div>
      <nav style={{backgroundColor: 'green'}} class="navbar navbar-expand-sm fixed-top">
    <div class="container">
      <a href="/"  className="navbar-brand bg-dark"><img style={{height: '70px', width: '70px'}} src="https://i.imgur.com/NFCLEv8.jpg"/></a>
        <button onClick={this.toggle} class="navbar-toggler bg-danger" data-toggle="collapse" data-target="#navbarCollapse">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div isOpen={this.state.isOpen} class="collapse navbar-collapse" id="navbarCollapse">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
          <a href="/"  class="nav-link">Home</a>
            </li>
            <li class="nav-item">
          <a href="/About" class="nav-link">About Us</a>
            </li>
  	<li class="nav-item">
          <a href="/Project" class="nav-link">Smart eco-city</a>
            </li>
            <li class="nav-item">
          <a href="/ProS" class="nav-link">Products & Services</a>
            </li>
            <li class="nav-item">
          <a href="/Invest" class="nav-link">Investing in Smart Eco-City</a>
            </li>
            <li class="nav-item">
          <a href="/Contact" class="nav-link">Contact</a>
            </li>
          </ul>
        </div>
    </div>
  </nav>
  {/* <Navbar color="inverse" light expand="md">
      <NavbarBrand href="/"><img  id="logo" src="https://i.imgur.com/TbDQ9cu.png" alt=""/></NavbarBrand>
      <NavbarToggler onClick={this.toggle} />
      <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
              <NavItem style={{color: "	#122F8B !impotant"}}>
                  <NavLink  href="/Home">Home</NavLink>
                  <NavLink href="/About">About Us</NavLink>
                  <NavLink href="/Contact">Contact</NavLink>
                  <NavLink href="/Direction">Direction</NavLink>
              </NavItem>
             
          </Nav>
      </Collapse>
  </Navbar> */}
</div>
    )
}
}
export default NavbarCustom;
